// Components
import GlobalUserFields from './GlobalUserFields';
import ProjectUserFields from './ProjectUserFields';
import FormError from '../../../shared/components/FormError'

class CompanyUserForm extends React.Component {
  constructor(props) {
    super(props)
    this.accessTypeOptions = [
      { value: 'company', label: 'Grant global company access' },
      { value: 'project', label: 'Grant access to specific projects' }
    ]
    this.projectOptions = props.projects
    this.state = {
      accessType: this.accessTypeOptions.find(opt => opt.value === (props.companyUser ? props.companyUser.access_type : 'company')),
      selectedProjects: props.companyUser ?
        this.projectOptions.filter(proj => props.companyUser.user.accessible_project_ids.find(id => id === proj.value)) :
        [],
      errors: []
    }
    this.onAccessTypeChange = this.onAccessTypeChange.bind(this)
    this.onProjectsSelectChangeHandler = this.onProjectsSelectChangeHandler.bind(this)
    this.onFormSubmit = this.onFormSubmit.bind(this)
    this.onFormError = this.onFormError.bind(this)
  }
  onFormSubmit(event) {
    this.props.submitFormHandler({
      event,
      onError: err => this.onFormError(err)
    })
  }
  onFormError(errors) {
    this.setState(() => ({ errors: errors }))
  }
  onAccessTypeChange(accessType) {
    this.setState(() => ({ accessType }))
  }
  onProjectsSelectChangeHandler(selectedProjects) {
    this.setState(() => ({ selectedProjects }))
  }
  render() {
    const { companyUser, projects } = this.props
    const { user } = companyUser || {}
    return (
      <tr className="inline-company-user-form">
        <td colSpan="10">
          <form acceptCharset="UTF-8" onSubmit={this.onFormSubmit}>
            {
              this.state.errors.length > 0 && <FormError errors={this.state.errors} />
            }
            <input name="utf8" type="hidden" value="&#10003;" />
            <div className="form-inputs row">
              <div className="col-md-8 col-md-offset-2">
                <div className="form-group">
                  <label htmlFor="first_name" className="control-label">First name</label>
                  <input type="text"
                    name="first_name"
                    className="form-control"
                    defaultValue={ user && user.first_name }
                    disabled={ companyUser && companyUser.id } />
                </div>
                <div className="form-group">
                  <label htmlFor="last_name" className="control-label">Last name</label>
                  <input type="text"
                    name="last_name"
                    className="form-control"
                    defaultValue={ user && user.last_name }
                    disabled={ companyUser && companyUser.id } />
                </div>
                <div className="form-group">
                  <label htmlFor="email" className="control-label">Email</label>
                  <input type="email"
                    name="email"
                    className="form-control"
                    defaultValue={ user && user.email }
                    disabled={ companyUser && companyUser.id }
                    required={ !companyUser } />
                </div>
                <div className="form-group">
                  <label htmlFor="access_type" className="control-label">Access type</label>
                  <Select options={ this.accessTypeOptions }
                    value={ this.state.accessType }
                    onChange={ this.onAccessTypeChange }
                    name="access_type" />
                </div>
                {
                  this.state.accessType.value === 'company' ?
                    <GlobalUserFields companyUser={companyUser} /> :
                    <ProjectUserFields companyUser={companyUser}
                      projects={ projects }
                      onChangeHandler={ this.onProjectsSelectChangeHandler }
                      projectOptions={ this.projectOptions }
                      selectedProjects={ this.state.selectedProjects } />
                }
              </div>
            </div>
            <div className="inline-form-actions row">
              <button type="submit" className="btn btn-primary">Save</button>&nbsp;
              <button onClick={this.props.closeFormHandler} className="btn btn-default">Cancel</button>
            </div>
          </form>
        </td>
      </tr>
    )
  }
}

const mapStateToProps = ({ projects }) => ({ projects })

export default connect(mapStateToProps)(CompanyUserForm)



// WEBPACK FOOTER //
// ./app/javascript/reactFeatures/company-users/components/forms/CompanyUserForm.js